import React, { useState, useCallback } from "react";
import { BlockEditProps } from "@wordpress/blocks";
import type { BlockAttributes } from "./block.json";
import { useBlockProps } from "@wordpress/block-editor";

export default function FormEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "" });

  return (
    <>
      <div {...blockProps}>
        <div className="d-flex justify-content-center py-5">
          <div className="form-container white d-flex flex-column">
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h4>Betreff</h4>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      value="Hausführung für Gruppen"
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6"></div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h4 className="mt-3">KONTAKTANGABEN</h4>
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="kontaktperson"
                      placeholder="Kontaktperson"
                      required
                    />
                    <label htmlFor="kontaktperson">Kontaktperson*</label>
                  </div>

                  <div className="form-floating mb-3">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="E-mail"
                      required
                    />
                    <label htmlFor="email">E-Mail*</label>
                  </div>

                  <div className="form-floating mb-3">
                    <input
                      type="tel"
                      className="form-control"
                      id="telephone"
                      placeholder="Telephone"
                      required
                    />
                    <label htmlFor="telephone">Telefon*</label>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="date">Wunschdatum*</label>
                      <div className="custom-date-input">
                        <input
                          type="date"
                          className="form-control"
                          id="date"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-6">
                      <label htmlFor="time">Wunschuhrzeit*</label>
                      <div className="custom-time-input">
                        <input
                          type="time"
                          className="form-control"
                          id="time"
                          name="appointment"
                          min="07:00"
                          max="24:00"
                          required
                        />
                      </div>
                      <input type="hidden" id="hidden-time" />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-6 d-flex flex-column justify-content-end">
                  <div className="form-floating mt-3">
                    <input
                      type="number"
                      className="form-control"
                      id="group-size"
                      placeholder="10"
                      required
                    />
                    <label htmlFor="group-size">Gruppengröße*</label>
                  </div>

                  <div className="form-floating mt-3">
                    <input
                      type="text"
                      className="form-control"
                      id="group-info"
                      placeholder="Information"
                      required
                    />
                    <label htmlFor="group-info">
                      Gruppeninformation (Schulklasse etc.)*
                    </label>
                  </div>

                  <div className="form-floating mt-3">
                    <textarea
                      className="form-control"
                      id="nachricht"
                      placeholder="Nachricht"
                    ></textarea>
                    <label htmlFor="nachricht">Nachricht</label>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-lg-6"></div>
                <div className="col-lg-6">
                  <p className="copy-s">Datenschutz*</p>
                  <div className="ps-2 mb-5 form-check d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="datenschutz"
                      required
                    />
                    <p className="copy-s ps-3">
                      Ich erkläre mich damit einverstanden, dass der Gebetshaus
                      e.V. meine Daten verarbeitet. Die Übermittlung dieser
                      Informationen erfolgt freiwillig und ist jederzeit
                      widerrufbar.
                    </p>
                  </div>

                  <button type="submit" className="button align-self-end">
                    Absenden
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
